import React from 'react'
import { Layout } from '../../../../components'
import CurrentStatus from './current-status'
import Header from '../../../../components/header'

import './style.scss'
import data from './data.json'
import changelog from '../../../../data/changelog.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug="general/current-status/develop/"
        state="develop"
        title={data.title}
      />
      <Layout
        category={data.category}
        description={data.description}
        state="develop"
        site={data.site}
        slug="general/current-status/develop/"
        title={data.title}
        updated={changelog[data.title].lastUpdated}
        complete={true}
      >
        <CurrentStatus />
      </Layout>
    </>
  )
}
